import ARAgingDashboard from './ARAgingDashboard2'
import { MyContextProvider } from './Context/DashboardContext'

export default function ARContextFrame() {
    return (
        <MyContextProvider>
            <ARAgingDashboard />
        </MyContextProvider>
    )
}
